import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FileDownloadService {
    constructor(@Inject(DOCUMENT) private document: Document) {}

    public saveAs(blob: Blob, fileName: string): void {
        const url = URL.createObjectURL(blob);
        const anchor = this.document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        anchor.style.display = 'none';

        try {
            this.document.body.appendChild(anchor);
            anchor.click();
        } finally {
            setTimeout(() => URL.revokeObjectURL(url), 0);
            this.document.body.removeChild(anchor);
        }
    }
}
